import { ReactNode } from 'react';

interface CardColumnProps {
    children: ReactNode;
    className?: string;
}

export function CardColumn({ children, className = '' }: CardColumnProps) {
    return <div className={`grid gap-6 max-w-7xl ${className}`}>{children}</div>;
}
